import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraggableListComponent } from './draggable-list.component';
import { AccordionModule } from '../accordion/accordion.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DragulaModule } from 'ng2-dragula';

@NgModule({
  declarations: [DraggableListComponent],
  imports: [CommonModule, AccordionModule, SharedModule, DragulaModule.forRoot()],
  exports: [DraggableListComponent]
})
export class DraggableListModule {}
